export function validateDate(value) {
    if (value === 0 || value.length < 10) {
        return false;
    }
    let reg = /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/g;

    return value.match(reg) !== null;
}

export function utcToDateString(utcTime, options) {
    const date = new Date(utcTime);
    return date.toLocaleDateString('de-DE', options);
}
